import React, { useState, useEffect } from "react";
import styled from "styled-components";

import FormGroup from "live/components/forms/ui/form-group";
import SubmitOrCancel from "live/components/forms/ui/submit-or-cancel";

import PerspectivesBox from "./PerspectivesBox";
import UsersBox from "./UsersBox";
import {
  createUserGroupApi,
  updateUserGroupApi,
} from "../../../api/userGroupApi";
import "./../../../../assets/scss/form.scss";
import "./../../../../assets/scss/select.scss";
import i18n from "live/services/i18n";

const UserGroup = ({
  userGroup,
  company,
  selectUserGroup,
  reloadUserGroupList,
}) => {
  const [messageErrorName, setMessageErrorName] = useState("");
  const [messageErrorResponseApi, setMessageErrorResponseApi] = useState();
  const [userGroupSelected, setUserGroupSelected] = useState({
    name: "",
    perspectives: [],
    users: [],
  });

  useEffect(() => {
    if (userGroup.id) {
      setUserGroupSelected(userGroup);
    }
  }, []);

  const addPerspective = (perspective) => {
    setUserGroupSelected({
      ...userGroupSelected,
      perspectives: [perspective, ...userGroupSelected.perspectives],
    });
  };

  const removePerspective = (perspectiveToRemove) => {
    setUserGroupSelected({
      ...userGroupSelected,
      perspectives: userGroupSelected.perspectives.filter((perspective) => {
        return perspective.id != perspectiveToRemove.id;
      }),
    });
  };

  const addUser = (user) => {
    setUserGroupSelected({
      ...userGroupSelected,
      users: [user, ...userGroupSelected.users],
    });
  };

  const removeUser = (userToRemove) => {
    setUserGroupSelected({
      ...userGroupSelected,
      users: userGroupSelected.users.filter((user) => {
        return user.id != userToRemove.id;
      }),
    });
  };

  const saveNewUserGroup = () => {
    const canSave = validName(userGroupSelected.name);

    if (canSave) {
      if (userGroupSelected.id) {
        updateDB(userGroupSelected);
      } else {
        saveDB(userGroupSelected);
      }
    }
  };

  const saveDB = (userGroup) => {
    createUserGroupApi(userGroup).then((response) => {
        cancel();
    })
    .catch(error => {
      setMessageErrorResponseApi(error?.response?.data?.message || error?.response?.data);
    });
  };

  const updateDB = (userGroup) => {
    updateUserGroupApi(userGroup).then((response) => {
        cancel();
    })
    .catch(error => {
      setMessageErrorResponseApi(error?.response?.data?.message || error?.response?.data);
    });
  };

  const validName = (name) => {    
    let isValid = true;
    setMessageErrorName("");

    if (name === "") {
      setMessageErrorName("Name can't be empty");
      isValid = false;
    }

    return isValid;
  };

  const _handleOnChangeName = (event) => {
    const name = event.target.value;
    validName(name);
    setUserGroupSelected({ ...userGroupSelected, name: event.target.value });
  };

  const cancel = () => {
    selectUserGroup(null);
    reloadUserGroupList();
    setMessageErrorResponseApi();
  };

  return (
    <UserGroupBox>
      <div className="userGroup-data">
        <FormGroup
          className={messageErrorName !== "" ? "custom-form-group-danger" : ""}
          type="text"
          disabled={false}
          label="Name"
          value={userGroupSelected.name}
          onChange={_handleOnChangeName.bind(this)}
          help={messageErrorName !== "" ? i18n(messageErrorName) : ""}
        />
        <UsersBox
          company={company}
          userGroup={userGroupSelected}
          addUser={addUser}
          removeUser={removeUser}
        />
        <SubmitOrCancel
          disabled={false}
          // saving={null}
          // saved={null}
          // error={null || null}
          // mustSave={null}
          // valid={null}
          onSubmit={() => saveNewUserGroup()}
          onCancel={() => cancel()}
          hideCancel={false}
        />

        <div class="custom-form-group-danger">
          <span class="custom-form-group-danger help-block">{messageErrorResponseApi}</span>
        </div>
      </div>
      <div className="userGroup-users-perspective">
        <PerspectivesBox
          company={company}
          userGroup={userGroupSelected}
          addPerspective={addPerspective}
          removePerspective={removePerspective}
        />
      </div>
    </UserGroupBox>
  );
};

const UserGroupBox = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;

  .userGroup-data {
    flex: 1 1 auto;
    padding: 20px;
  }

  .userGroup-users-perspective {
    flex: 0 1 300px;
  }
`;

export default UserGroup;
